import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import { useSelector } from "react-redux";
import { Endpoints } from "../../Global/Endpoints";
import { useTranslation } from "react-i18next";
import ChatBotWindow from "../ChatBot/ChatBotWindow";
import { useChat } from "../Layout/ChatContext";

const MyDocuments = () => {
    const { t } = useTranslation();
    const [documents, setDocuments] = useState([]);
    const [loading, setLoading] = useState(true); // Track loading state
    const navigate = useNavigate();
    const contract = useSelector((state) => state.userData);
    const token = localStorage.getItem("AccessToken") || "YOUR_ACCESS_TOKEN_HERE";
    const { isChatVisible, toggleChat, showChat } = useChat();

    const ssoData = useSelector((state) => state.sso.ssoUserData);
    const isHighmarkPortal = ssoData?.Portal === "Highmark";

    useEffect(() => {
        const fetchDocuments = async () => {
            setLoading(true); // Start loading
            try {
                const payload = {
                    _Params: JSON.stringify({ EmailID: contract.userData.EmailID, DeviceType: "PatientPortal" }),
                };
                const response = await axios.post(
                    Endpoints.LoadAuth,
                    payload,
                    {
                        headers: {
                            "Content-Type": "application/x-www-form-urlencoded",
                            Authorization: `Bearer ${token}`,
                        },
                    }
                );

                if (response.data && response.data.length > 0) {
                    const formattedDocuments = response.data.map((doc) => ({
                        AuthNo: doc.AuthNo || "Unknown AuthNo",
                        CPTDesc: doc.CPTDesc || "Unknown Description",
                        Contract: doc.Contract || contract.userData.Contract || "Unknown Contract",
                        MemberID: doc.MemberID || contract.userData.MemberID || "Unknown MemberID",
                        Date: doc.Date || "No Date Provided",
                    }));
                    setDocuments(formattedDocuments);
                } else {
                    setDocuments([]); // Set empty documents
                }
            } catch (error) {
                toast.error(t("failedtoloaddocuments1"));
            }
            setLoading(false); // Stop loading
        };

        fetchDocuments();
    }, [token, contract.userData]);

    const handleDocumentClick = (document) => {
        navigate("/load-pdf", {
            state: {
                document: {
                    AuthNo: document.AuthNo,
                    CPTDesc: document.CPTDesc,
                    Contract: document.Contract,
                    MemberID: document.MemberID,
                },
            },
        });
    };

    return (
        <>
            <ToastContainer />

            {isHighmarkPortal ? 
            <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
            <button className="win-back-btn" onClick={() => navigate(-1)}>
                <span>
                <i className="bi bi-chevron-left"></i>
                </span>
            </button>       
            <h2 className="page-heading">{t('mydocuments')}</h2>
            </div>:
            <div className="col-md-6 mt-4 d-flex inner-page-heading-wrapper">
            <button className="win-back-btn" onClick={() => navigate(-1)}>
                <span>
                <i className="bi bi-chevron-left"></i>    
                {t('Back')}        
                </span>
            </button>       
            <h2 className="page-heading">{t('mydocuments')}</h2>
            </div>
          }

            {/* <div className="col-md-12 col-lg-12 mt-4 inner-page-heading-wrapper">
                <button className="win-back-btn" onClick={() => navigate(-1)}>
                    <span>
                        <i className="bi bi-chevron-left"></i> {t("back")}
                    </span>
                </button>
                <h2 className="page-heading">{t("mydocuments")}</h2>
            </div> */}

            <div className="col-md-12 col-lg-12 mt-0">
                {loading ? (
                    <div className="loading-container">
                        <div className="loading"></div>
                        <h2 className="loading-text">{t("loading")}</h2>
                    </div>
                ) : documents.length > 0 ? (
                    <div className="documents-list">
                        {documents.map((document, index) => (
                            <div
                                key={index}
                                className="document-item"
                                onClick={() => handleDocumentClick(document)}
                            >
                                <div className="document-titles-wrapper">
                                    <strong>{document.CPTDesc}</strong>
                                    <p>{document.AuthNo}</p>
                                </div>
                                <div className="document-type-icon-wrapper document-type-pdf"></div>
                            </div>
                        ))}
                    </div>
                ) : (
                    <p style={{ color: "gray", textAlign: "center" }}>
                        <div className="no-data-available">{t("nodocumentdata")}</div>;
                    </p>
                )}
            </div>
            {/* {isChatVisible && <ChatBotWindow />} */}
        </>
    );
};

export default MyDocuments;
